
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';

const LeagueRoutes = {
  id: 'League-group',
  title: 'League Management',
  type: 'group',
  children: [
    {
      id: 'League-list',
      title: 'League List',
      type: 'item',
      url: '/league/list',
      icon: SportsSoccerIcon,
      target: false
    }
  ]
};

export default LeagueRoutes;
